import { DesktopOutlined } from "@ant-design/icons";
import { BlogDetailPage, BlogPage, LandingPage, PrivacyPolicy, TermsAndConditions } from "pages/Landing";
import landingRouteMap from "routeControl/landingRouteMap";

/**
 * Generates an array of route objects for admin authentication-related pages.
 * @returns {Array} An array containing route objects for admin authentication pages.
 */
export default function route() {
  // Define a reusable icon for the routes
  const routeIcon = <DesktopOutlined />;
  return [
    {
      path: landingRouteMap.LANDING.path,
      name: "Landing",
      key: landingRouteMap.LANDING.path,
      private: false, 
      belongsToSidebar: false,
      icon: routeIcon,
      element: <LandingPage />,
    },
    {
      path: landingRouteMap.BLOGS.path,
      name: "Blogs",
      key: landingRouteMap.BLOGS.path,
      private: false, 
      belongsToSidebar: false,
      icon: routeIcon,
      element: <BlogPage />,
    },
    {
      path: landingRouteMap.BLOGS_DETAIL.path,
      name: "Blog details",
      key: landingRouteMap.BLOGS_DETAIL.path,
      private: false, 
      belongsToSidebar: false,
      icon: routeIcon,
      element: <BlogDetailPage />,
    },
    {
      path: landingRouteMap.TERMS_AND_CONDITIONS.path,
      name: "Terms and Conditions",
      key: landingRouteMap.TERMS_AND_CONDITIONS.path,
      private: false, 
      belongsToSidebar: false,
      icon: routeIcon,
      element: <TermsAndConditions />,
    },
    {
      path: landingRouteMap.PRIVACY_POLICY.path,
      name: "Privacy Policy",
      key: landingRouteMap.PRIVACY_POLICY.path,
      private: false, 
      belongsToSidebar: false,
      icon: routeIcon,
      element: <PrivacyPolicy />,
    },
  ];
}
